import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { useMediaQuery } from '@mui/material';


import { NavLink, useLocation } from "react-router-dom";
import { Fragment, useState } from "react";
import {
    Calendar,
    Dashboard,
    ForgetPassword,
    LogOut,
    Price,
    Requests,
    User,
    UserList,
    Users
} from "../../../assets/icones/icones";


import logoapp from '../../../assets/images/logo.png'
import clientconfigwebapp from "../../../clientconfigwebapp";



const drawerWidth = 340;

function ResponsiveDrawer(props) {
    const { window, mobileOpen, handleDrawerToggle } = props;
    const isMobile = useMediaQuery('(max-width:768px)');

    const location = useLocation();
    const [status, setStatus] = useState(false);


    const list_menu_user_simple = [
        {
            text: 'پیشخوان',
            icon: <Dashboard />,
            href: '/panel/dashboard'
        },
        {
            text: 'ثبت درخواست خرید',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2137_1956)"><path d="M19 5V14H14V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM12 14H7V12H12V14ZM17 10H7V8H17V10Z" fill="#9ca3af"/></g><defs><clipPath id="clip0_2137_1956"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>,
            href: '/panel/request-reg'
        },   {
            text: 'درخواست های من',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2137_1956)"><path d="M19 5V14H14V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM12 14H7V12H12V14ZM17 10H7V8H17V10Z" fill="#9ca3af"/></g><defs><clipPath id="clip0_2137_1956"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>,
            href: '/panel/requests'
        },

        {
            text: 'فروشندگان پیشنهادی',
            icon: <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 16.5C21 16.88 20.79 17.21 20.47 17.38L12.57 21.82C12.41 21.94 12.21 22 12 22C11.79 22 11.59 21.94 11.43 21.82L3.53 17.38C3.21 17.21 3 16.88 3 16.5V7.5C3 7.12 3.21 6.79 3.53 6.62L11.43 2.18C11.59 2.06 11.79 2 12 2C12.21 2 12.41 2.06 12.57 2.18L20.47 6.62C20.79 6.79 21 7.12 21 7.5V16.5ZM12 4.15L10.11 5.22L16 8.61L17.96 7.5L12 4.15ZM6.04 7.5L12 10.85L13.96 9.75L8.08 6.35L6.04 7.5ZM5 15.91L11 19.29V12.58L5 9.21V15.91ZM19 15.91V9.21L13 12.58V19.29L19 15.91Z" fill="#9CA3AF"/></svg>,
            href: '/panel/suggested-vendors'
        },
        {
            text: 'تیکت ها',
            icon: <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_0_5129)"><path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 10.99L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="#9CA3AF"/></g><defs><clipPath id="clip0_0_5129"><rect width={24} height={24} fill="white"/></clipPath></defs></svg>,
            href: '/panel/tickets'
        },
        {
            text: 'احراز هویت',
            icon: <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 10.99L19.56 8.2L19.9 4.51L16.29 3.69L14.4 0.5L11 1.96L7.6 0.5L5.71 3.69L2.1 4.5L2.44 8.2L0 10.99L2.44 13.78L2.1 17.48L5.71 18.3L7.6 21.5L11 20.03L14.4 21.49L16.29 18.3L19.9 17.48L19.56 13.79L22 10.99ZM18.05 12.47L17.49 13.12L17.57 13.97L17.75 15.92L15.85 16.35L15.01 16.54L14.57 17.28L13.58 18.96L11.8 18.19L11 17.85L10.21 18.19L8.43 18.96L7.44 17.29L7 16.55L6.16 16.36L4.26 15.93L4.44 13.97L4.52 13.12L3.96 12.47L2.67 11L3.96 9.52L4.52 8.87L4.43 8.01L4.25 6.07L6.15 5.64L6.99 5.45L7.43 4.71L8.42 3.03L10.2 3.8L11 4.14L11.79 3.8L13.57 3.03L14.56 4.71L15 5.45L15.84 5.64L17.74 6.07L17.56 8.02L17.48 8.87L18.04 9.52L19.33 10.99L18.05 12.47Z" fill="#9CA3AF"/><path d="M9.08906 12.75L6.76906 10.42L5.28906 11.91L9.08906 15.72L16.4291 8.35999L14.9491 6.87L9.08906 12.75Z" fill="#9CA3AF"/></svg>
            ,
            href: '/panel/authentication'
        },
        {
            text: 'نظر سنجی',
            icon: <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_0_4767)"><path d="M12 6C12 5.45 11.55 5 11 5H5.82L6.48 1.82L6.5 1.59C6.5 1.28 6.37 1 6.17 0.79L5.38 0L0.44 4.94C0.17 5.21 0 5.59 0 6V12.5C0 13.33 0.67 14 1.5 14H8.25C8.87 14 9.4 13.62 9.63 13.09L11.89 7.8C11.96 7.63 12 7.44 12 7.25V6ZM10 7.13L7.92 12H2V6.21L3.93 4.28L3.36 7H10V7.13ZM22.5 10H15.75C15.13 10 14.6 10.38 14.37 10.91L12.11 16.2C12.04 16.37 12 16.56 12 16.75V18C12 18.55 12.45 19 13 19H18.18L17.52 22.18L17.5 22.42C17.5 22.73 17.63 23.01 17.83 23.22L18.62 24L23.56 19.06C23.83 18.79 24 18.41 24 18V11.5C24 10.67 23.33 10 22.5 10ZM22 17.79L20.07 19.72L20.64 17H14V16.87L16.08 12H22V17.79Z" fill="#9CA3AF"/></g><defs><clipPath id="clip0_0_4767"><rect width={24} height={24} fill="white"/></clipPath></defs></svg>,
            href: '/panel/comments'
        },
        {
            text: 'حساب کاربری',
            icon: <User/>,
            href: '/panel/profile'
        },
        {
            text: 'خروج',
            icon: <LogOut/>,
            href: '/login-register'
        }
    ];

    const list_menu_user_seller = [
        {
            text: 'پیشخوان',
            icon: <Dashboard />,
            href: '/panel/dashboard'
        },
        {
            text: 'درخواست های خرید',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2137_1956)"><path d="M19 5V14H14V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM12 14H7V12H12V14ZM17 10H7V8H17V10Z" fill="#9ca3af"/></g><defs><clipPath id="clip0_2137_1956"><rect width="24" height="24" fill="white"/></clipPath></defs></svg>,
            href: '/requirements'
        },

        {
            text: 'ثبت محصول جدید',
            icon: <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 16.5C21 16.88 20.79 17.21 20.47 17.38L12.57 21.82C12.41 21.94 12.21 22 12 22C11.79 22 11.59 21.94 11.43 21.82L3.53 17.38C3.21 17.21 3 16.88 3 16.5V7.5C3 7.12 3.21 6.79 3.53 6.62L11.43 2.18C11.59 2.06 11.79 2 12 2C12.21 2 12.41 2.06 12.57 2.18L20.47 6.62C20.79 6.79 21 7.12 21 7.5V16.5ZM12 4.15L10.11 5.22L16 8.61L17.96 7.5L12 4.15ZM6.04 7.5L12 10.85L13.96 9.75L8.08 6.35L6.04 7.5ZM5 15.91L11 19.29V12.58L5 9.21V15.91ZM19 15.91V9.21L13 12.58V19.29L19 15.91Z" fill="#9CA3AF"/></svg>,
            href: '/panel/product-registration'
        },

        {
            text: 'محصولات من',
            icon: <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 16.5C21 16.88 20.79 17.21 20.47 17.38L12.57 21.82C12.41 21.94 12.21 22 12 22C11.79 22 11.59 21.94 11.43 21.82L3.53 17.38C3.21 17.21 3 16.88 3 16.5V7.5C3 7.12 3.21 6.79 3.53 6.62L11.43 2.18C11.59 2.06 11.79 2 12 2C12.21 2 12.41 2.06 12.57 2.18L20.47 6.62C20.79 6.79 21 7.12 21 7.5V16.5ZM12 4.15L10.11 5.22L16 8.61L17.96 7.5L12 4.15ZM6.04 7.5L12 10.85L13.96 9.75L8.08 6.35L6.04 7.5ZM5 15.91L11 19.29V12.58L5 9.21V15.91ZM19 15.91V9.21L13 12.58V19.29L19 15.91Z" fill="#9CA3AF"/></svg>,
            href: '/panel/my-products'
        },
        {
            text: 'تیکت ها',
            icon: <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_0_5129)"><path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 10.99L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="#9CA3AF"/></g><defs><clipPath id="clip0_0_5129"><rect width={24} height={24} fill="white"/></clipPath></defs></svg>,
            href: '/panel/tickets'
        },
        {
            text: 'احراز هویت',
            icon: <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 10.99L19.56 8.2L19.9 4.51L16.29 3.69L14.4 0.5L11 1.96L7.6 0.5L5.71 3.69L2.1 4.5L2.44 8.2L0 10.99L2.44 13.78L2.1 17.48L5.71 18.3L7.6 21.5L11 20.03L14.4 21.49L16.29 18.3L19.9 17.48L19.56 13.79L22 10.99ZM18.05 12.47L17.49 13.12L17.57 13.97L17.75 15.92L15.85 16.35L15.01 16.54L14.57 17.28L13.58 18.96L11.8 18.19L11 17.85L10.21 18.19L8.43 18.96L7.44 17.29L7 16.55L6.16 16.36L4.26 15.93L4.44 13.97L4.52 13.12L3.96 12.47L2.67 11L3.96 9.52L4.52 8.87L4.43 8.01L4.25 6.07L6.15 5.64L6.99 5.45L7.43 4.71L8.42 3.03L10.2 3.8L11 4.14L11.79 3.8L13.57 3.03L14.56 4.71L15 5.45L15.84 5.64L17.74 6.07L17.56 8.02L17.48 8.87L18.04 9.52L19.33 10.99L18.05 12.47Z" fill="#9CA3AF"/><path d="M9.08906 12.75L6.76906 10.42L5.28906 11.91L9.08906 15.72L16.4291 8.35999L14.9491 6.87L9.08906 12.75Z" fill="#9CA3AF"/></svg>
            ,
            href: '/panel/authentication'
        },
        {
            text: 'نظر سنجی',
            icon: <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_0_4767)"><path d="M12 6C12 5.45 11.55 5 11 5H5.82L6.48 1.82L6.5 1.59C6.5 1.28 6.37 1 6.17 0.79L5.38 0L0.44 4.94C0.17 5.21 0 5.59 0 6V12.5C0 13.33 0.67 14 1.5 14H8.25C8.87 14 9.4 13.62 9.63 13.09L11.89 7.8C11.96 7.63 12 7.44 12 7.25V6ZM10 7.13L7.92 12H2V6.21L3.93 4.28L3.36 7H10V7.13ZM22.5 10H15.75C15.13 10 14.6 10.38 14.37 10.91L12.11 16.2C12.04 16.37 12 16.56 12 16.75V18C12 18.55 12.45 19 13 19H18.18L17.52 22.18L17.5 22.42C17.5 22.73 17.63 23.01 17.83 23.22L18.62 24L23.56 19.06C23.83 18.79 24 18.41 24 18V11.5C24 10.67 23.33 10 22.5 10ZM22 17.79L20.07 19.72L20.64 17H14V16.87L16.08 12H22V17.79Z" fill="#9CA3AF"/></g><defs><clipPath id="clip0_0_4767"><rect width={24} height={24} fill="white"/></clipPath></defs></svg>,
            href: '/panel/comments'
        },
        {
            text: 'حساب کاربری',
            icon: <User/>,
            href: '/panel/profile'
        },
        {
            text: 'خروج',
            icon: <LogOut/>,
            href: '/login-register'
        }
    ];

    const drawer = (
        <Fragment>
            <div className='back_dark'></div>
            <aside className='panel_aside'>
                <span className='menu_btn_pnael_mobile btn_close' onClick={handleDrawerToggle} style={{transform: 'rotate(180deg)'}}>
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                        <g id="SVGRepo_bgCarrier" strokeWidth={0}/>
                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                        <g id="SVGRepo_iconCarrier">
                            <path
                                d="M10.0303 8.96967C9.73741 8.67678 9.26253 8.67678 8.96964 8.96967C8.67675 9.26256 8.67675 9.73744 8.96964 10.0303L10.9393 12L8.96966 13.9697C8.67677 14.2626 8.67677 14.7374 8.96966 15.0303C9.26255 15.3232 9.73743 15.3232 10.0303 15.0303L12 13.0607L13.9696 15.0303C14.2625 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2625 15.0303 13.9697L13.0606 12L15.0303 10.0303C15.3232 9.73746 15.3232 9.26258 15.0303 8.96969C14.7374 8.6768 14.2625 8.6768 13.9696 8.96969L12 10.9394L10.0303 8.96967Z"
                                fill="#ffffff"/>
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M12.0574 1.25H11.9426C9.63424 1.24999 7.82519 1.24998 6.41371 1.43975C4.96897 1.63399 3.82895 2.03933 2.93414 2.93414C2.03933 3.82895 1.63399 4.96897 1.43975 6.41371C1.24998 7.82519 1.24999 9.63422 1.25 11.9426V12.0574C1.24999 14.3658 1.24998 16.1748 1.43975 17.5863C1.63399 19.031 2.03933 20.1711 2.93414 21.0659C3.82895 21.9607 4.96897 22.366 6.41371 22.5603C7.82519 22.75 9.63423 22.75 11.9426 22.75H12.0574C14.3658 22.75 16.1748 22.75 17.5863 22.5603C19.031 22.366 20.1711 21.9607 21.0659 21.0659C21.9607 20.1711 22.366 19.031 22.5603 17.5863C22.75 16.1748 22.75 14.3658 22.75 12.0574V11.9426C22.75 9.63423 22.75 7.82519 22.5603 6.41371C22.366 4.96897 21.9607 3.82895 21.0659 2.93414C20.1711 2.03933 19.031 1.63399 17.5863 1.43975C16.1748 1.24998 14.3658 1.24999 12.0574 1.25ZM3.9948 3.9948C4.56445 3.42514 5.33517 3.09825 6.61358 2.92637C7.91356 2.75159 9.62177 2.75 12 2.75C14.3782 2.75 16.0864 2.75159 17.3864 2.92637C18.6648 3.09825 19.4355 3.42514 20.0052 3.9948C20.5749 4.56445 20.9018 5.33517 21.0736 6.61358C21.2484 7.91356 21.25 9.62177 21.25 12C21.25 14.3782 21.2484 16.0864 21.0736 17.3864C20.9018 18.6648 20.5749 19.4355 20.0052 20.0052C19.4355 20.5749 18.6648 20.9018 17.3864 21.0736C16.0864 21.2484 14.3782 21.25 12 21.25C9.62177 21.25 7.91356 21.2484 6.61358 21.0736C5.33517 20.9018 4.56445 20.5749 3.9948 20.0052C3.42514 19.4355 3.09825 18.6648 2.92637 17.3864C2.75159 16.0864 2.75 14.3782 2.75 12C2.75 9.62177 2.75159 7.91356 2.92637 6.61358C3.09825 5.33517 3.42514 4.56445 3.9948 3.9948Z"
                                  fill="#ffffff"/>
                        </g>
                    </svg>
                </span>


                <div style={{
                    "display": "flex",
                    "flexDirection": "column",
                    "alignContent": "center",
                    "alignItems": "center",
                    "paddingTop": "33px",
                    "paddingBottom": "20px"
                }}><img style={{width: "100px"}} className={"logo-menu"} src={logoapp} alt={"logo"}/></div>

                <div className={"box-info-user-menu"}>
                    <img className={"menu-image-profile"} src={props.profile_src} alt="profile"/>

                    <span className={"first_last_name_menupanel"}>{props.first_name_profile} {props.last_name_profile} </span>
                    <span className={"city_menupanel"}>خراسان رضوی - مشهد</span>

                </div>



                <div className={"btn-switch-panel"}>
                    <a href={String(clientconfigwebapp.webappurl) + "switch-panel/simple"}     className={props.type_user_panel === 'simple' ? 'btn-switch-active-menu' : 'btn-switch-deactive-menu'}
                       title={"خریدار"} ><span >خریدار</span>
                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 13C10.6739 13 9.40215 12.4732 8.46447 11.5355C7.52678 10.5979 7 9.32608 7 8H9C9 8.79565 9.31607 9.55871 9.87868 10.1213C10.4413 10.6839 11.2044 11 12 11C12.7956 11 13.5587 10.6839 14.1213 10.1213C14.6839 9.55871 15 8.79565 15 8H17C17 9.32608 16.4732 10.5979 15.5355 11.5355C14.5979 12.4732 13.3261 13 12 13ZM12 3C12.7956 3 13.5587 3.31607 14.1213 3.87868C14.6839 4.44129 15 5.20435 15 6H9C9 5.20435 9.31607 4.44129 9.87868 3.87868C10.4413 3.31607 11.2044 3 12 3ZM19 6H17C17 5.34339 16.8707 4.69321 16.6194 4.08658C16.3681 3.47995 15.9998 2.92876 15.5355 2.46447C15.0712 2.00017 14.52 1.63188 13.9134 1.3806C13.3068 1.12933 12.6566 1 12 1C10.6739 1 9.40215 1.52678 8.46447 2.46447C7.52678 3.40215 7 4.67392 7 6H5C3.89 6 3 6.89 3 8V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V8C21 6.89 20.1 6 19 6Z"
                                fill="white"/>
                        </svg>
                    </a>
                    <a href={String(clientconfigwebapp.webappurl) + "switch-panel/seller"} className={props.type_user_panel === 'seller' ? 'btn-switch-active-menu' : 'btn-switch-deactive-menu'}
                       title={"فروشنده"} ><span >فروشنده</span>
                        <svg width={25} height={24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.5 18H6.5V14H12.5M21.5 14V12L20.5 7H4.5L3.5 12V14H4.5V20H14.5V14H18.5V20H20.5V14M20.5 4H4.5V6H20.5V4Z"
                                fill="#9CA3AF"/>
                        </svg>
                    </a>
                </div>


                <ul className='flexColStartStart' style={{width: "100%"}}>
                    { props.type_user_panel === "seller" ? (
                        <Fragment>
                            {list_menu_user_seller.map((item) => (
                                <li key={item.href}>
                                    <NavLink reloadDocument={true} to={item.href} className={({isActive}) => {
                                        return isActive ? ' link_active' : '';
                                    }}>
                                        {item.icon}
                                        {item.text}
                                    </NavLink>
                                </li>
                            ))}
                        </Fragment>
                    ) : (
                        <Fragment></Fragment>
                    )}

                    { props.type_user_panel === "simple" ? (
                        <Fragment>

                            <li key={""}>
                                <NavLink reloadDocument={true} to={"/"}>
                                    <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth={0}/><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/><g id="SVGRepo_iconCarrier"><path d="M22 12.2039V13.725C22 17.6258 22 19.5763 20.8284 20.7881C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.7881C2 19.5763 2 17.6258 2 13.725V12.2039C2 9.91549 2 8.77128 2.5192 7.82274C3.0384 6.87421 3.98695 6.28551 5.88403 5.10813L7.88403 3.86687C9.88939 2.62229 10.8921 2 12 2C13.1079 2 14.1106 2.62229 16.116 3.86687L18.116 5.10812C20.0131 6.28551 20.9616 6.87421 21.4808 7.82274" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round"/><path d="M15 18H9" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round"/></g></svg>
                               صفحه اصلی
                                </NavLink>
                            </li>


                            {list_menu_user_simple.map((item) => (
                                <li key={item.href}>
                                    <NavLink reloadDocument={true} to={item.href} className={({isActive}) => {
                                        return isActive ? ' link_active' : '';
                                    }}>
                                        {item.icon}
                                        {item.text}
                                    </NavLink>
                                </li>
                            ))}
                        </Fragment>
                    ) : (
                        <Fragment></Fragment>
                    )}

                </ul>
            </aside>
        </Fragment>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Fragment>
            <Box
                component="nav"
                sx={{width: {sm: drawerWidth}, flexShrink: {sm: 0}}}
                aria-label="mailbox folders"
                className={"menu_side_barbk"}


            >
                <Drawer
                    container={container}
                    anchor="right"
                    variant={isMobile ? "temporary" : "permanent"}
                    open={isMobile ? mobileOpen : true}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                    }}
                >
                    {drawer}
                </Drawer>

            </Box>
        </Fragment>
    );
}

ResponsiveDrawer.propTypes = {
    window: PropTypes.func,
    mobileOpen: PropTypes.bool.isRequired,
    handleDrawerToggle: PropTypes.func.isRequired,
    type_user: PropTypes.string.isRequired
};

export default ResponsiveDrawer;
